import styled from 'styled-components';
import { colors } from 'bench-style-constants';

type ErrorBannerProps = {
  color?: string | undefined | null;
  backgroundColor?: string | undefined | null;
};

const ErrorBanner = styled.div<ErrorBannerProps>`
  background-color: ${({ backgroundColor }) => backgroundColor || '#fbefed'};
  padding: 16px;
  border-radius: 4px;

  p {
    color: ${({ color }) => color || colors.copper};
    font-size: 12px;
    font-weight: 300;
    margin: 0;
  }
`;

export default ErrorBanner;
